import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import {  map } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-angular-grids";
import { ErrorService } from "src/app/error.service";
@Injectable({
  providedIn: "root",
})
export class QPInfoService extends Subject<DataStateChangeEventArgs> {
  constructor(
    public errorService: ErrorService,
    private http: HttpClient,
    public global: GlobalComponent,
    public general: GeneralService
  ) {
    super();
  }
  // outputValuesClientRelationshipReport
  public outputValuesClientRelationshipReport(state): void {
    this.getQpEmployeeClientRelationshipReport(state).subscribe((x) => super.next(x));
  }
  // getQpEmployeeClientRelationshipReport
  getQpEmployeeClientRelationshipReport(
    state
  ): Observable<DataStateChangeEventArgs> {
    return this.http
      .post<any>("api/EmployeeClientMapping/getEmployeeClientMappingReport", state)
      .pipe(
        map(
          (response: any) =>
            <any>{
              result: response["result"],
              count: response["count"],
              // clientIds: response["clientIds"]

            }
        )
      );
  }
}
